import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Company, CountryDto, CityDto } from '../models/company.model';
import { Observable } from 'rxjs';
import { Internship } from '../models/internship';
import { InclusionIndexDashboard } from '../models/inclusionIndexDashboard';
import { environment } from '../environments/environment';
import { AvailableInternship } from '../models/availableInternship.models';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private http: HttpClient) { }

  private apiGetDetailCompany = environment.apiUrl + '/api/companies/me';

  getCompany(): Observable<Company> {
    const token = localStorage.getItem('token');

    const headers = {
      Authorization: `Bearer ${token}`
    };

  return this.http.get<Company>(this.apiGetDetailCompany,{headers});
  }

  updateCompany(data: FormData): Observable<Company> {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };

    return this.http.put<Company>(environment.apiUrl + '/api/companies/me', data, { headers });
  }

    uploadBadge(data: FormData): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };

    return this.http.put(environment.apiUrl + '/api/companies/me/upload-badge', data, { headers });
  }

  getInternshipsByCompany(): Observable<Internship[]> {
    const token = localStorage.getItem('token');

    const headers = {
      Authorization: `Bearer ${token}`
    };
    return this.http.get<Internship[]>(environment.apiUrl + `/api/internships-assigned`,{headers});
  }

    getSelfAssessments(): Observable<Internship[]> {
    const token = localStorage.getItem('token');

    const headers = {
      Authorization: `Bearer ${token}`
    };
    return this.http.get<Internship[]>(environment.apiUrl + `/api/companies/self-assessment`,{headers});
  }

  /* saveInternship(data: Internship): Observable<string> {
    const token = localStorage.getItem('token');

    const headers = {
      Authorization: `Bearer ${token}`
    };

    return this.http.post(environment.apiUrl + '/api/companies/internships', data, {
      headers: headers,
      responseType: 'text' as const,
    });
  } */

  saveInternship(availableInternshipId: number, data: any): Observable<string> {
    const token = localStorage.getItem('token');

    const headers = {
      Authorization: `Bearer ${token}`
    };

    return this.http.post(environment.apiUrl + `/api/internships-assigned?availableInternshipId=${availableInternshipId}`, data, {
      headers: headers,
      responseType: 'text' as const
    });
  }

  updateInternship(id: number, data: Internship): Observable<string> {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };

    return this.http.put(environment.apiUrl + `/api/internships-assigned/${id}`, data, {
      headers,
      responseType: 'text'
    });
  }

  deleteInternship(id: number): Observable<string> {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };

    return this.http.delete(environment.apiUrl + `/api/internships-assigned/${id}`, {
      headers,
      responseType: 'text'
    });
  }

  getInclusionIndexDashboard(): Observable<InclusionIndexDashboard> {
    const token = localStorage.getItem('token');

    const headers = {
      Authorization: `Bearer ${token}`
    };

    return this.http.get<InclusionIndexDashboard>(environment.apiUrl + `/api/companies/dashboard-simple`,{headers});
  }

  getAvailableInternships(): Observable<any[]> {
    const token = localStorage.getItem('token');
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return this.http.get<any[]>(environment.apiUrl + `/api/available-internships/me`,{headers});
  }

  sendReminderManually(id: number) {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem('token') 
    });

    return this.http.post(
      `${environment.apiUrl}/api/internship-emails/internships-assigned/${id}/sendReminder`,
      {},
      { headers, responseType: 'text' }
    );
  }

  getInternshipEmails(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return this.http.get<{ reminderMailSentAt: string; sentBy: string }[]>(`${environment.apiUrl}/api/internship-emails/internships-assigned/${id}/emails`,{headers});
  }

  
    createAvailableInternship(dto: any): Observable<AvailableInternship> {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
  
      console.log("create tirocini disponibili",environment.apiUrl);
  
      return this.http.post<AvailableInternship>(
        environment.apiUrl + `/api/available-internships/me`,
        dto,
        { headers }
      );
    }
    
    getNewIndex() {
      const token = localStorage.getItem('token') || '';
      const headers = { Authorization: `Bearer ${token}` };

      return this.http.post(
        `${environment.apiUrl}/api/companies/recalculate-index`,
        {},
        { headers, responseType: 'text' } // 👈 forziamo TEXT
      );
    }

    hasSelfAssessment(): Observable<boolean> {
      const token = localStorage.getItem('token') || '';
      const headers = { Authorization: `Bearer ${token}` };

      return this.http.get<boolean>(
        `${environment.apiUrl}/api/companies/self-assessment`,
        { headers }
      );
    }

    changePassword(oldPassword: string, newPassword: string, confirmNewPassword: string): Observable<string> {
      const token = localStorage.getItem('token') || '';
      const headers = { Authorization: `Bearer ${token}` };
      const dto = { oldPassword, newPassword };

      

      console.log("Service - changePassword DTO:", dto);

      if(newPassword !== confirmNewPassword) {
        throw new Error("New password and confirmation do not match.");
      }
      return this.http.put(
        `${environment.apiUrl}/api/companies/change-password`,
        dto,
        { headers, responseType: 'text' }
      );
    }

    getCountries(): Observable<CountryDto[]> {
      return this.http.get<CountryDto[]>(`${environment.apiUrl}/api/countries`);
    }

    getCities(): Observable<CityDto[]> {
      return this.http.get<CityDto[]>(`${environment.apiUrl}/api/cities`);
    }

    getCitiesSearch(id_country: number, search: string): Observable<CityDto[]> {
      const params = new HttpParams()
        .set('id_country', id_country.toString())
        .set('search', search);

      return this.http.get<CityDto[]>(
        `${environment.apiUrl}/api/cities/search`,
        { params }
      );
    }

    getSectors(): Observable<any[]> {
      return this.http.get<any[]>(`${environment.apiUrl}/api/companies/sectors`);
    }


}
